import React from "react";
import { UploadFileIcon } from "../../../assets/images";
import { TrashIcon } from "../../Icon";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";

type AppProps = {
  uploadFiles: (data: any) => void;
  files: any;
  handleDeleteUploadedFile: (data: any) => void;
  uploadFetching: boolean;
};
const LeaveFileUpload = ({
  uploadFiles,
  files,
  handleDeleteUploadedFile,
  uploadFetching,
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  return (
    <>
      <div className="mt-3 p-0 d-flex align-items-center">
        <div
          className="dropzone drop-area-single text-center"
          style={{
            cursor: "pointer",
            borderRadius: "8px",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <h4 className="text-center">
            <span
              style={{
                color: "#dd4433",
              }}
            >
              <img
                src={UploadFileIcon}
                style={{ width: "26px", marginRight: "-38px" }}
                alt="upload"
                className=""
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              />
              <label
                htmlFor="file-upload"
                style={{
                  color: "#dd4433",
                  paddingLeft: "2px",
                  cursor: "pointer",
                  width: "133px",
                  padding: "10px",
                  border: "1px solid #dd4433",
                  borderRadius: "5px",
                  textAlign: "end",
                }}
                className="btn-outline"
              >
                Attach File
              </label>

              <input
                type="file"
                id="file-upload"
                accept="image/png, image/jpeg, application/pdf ,  application/vnd.ms-excel , application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
                multiple
                onChange={uploadFiles}
                style={{ display: "none" }}
                onClick={(event: any) => {
                  event.target.value = null;
                }}
                disabled={uploadFetching}
              />
            </span>
          </h4>
        </div>
        <span className="ml-2" style={{ marginTop: "-17px" }}>
          {" "}
          {uploadFetching ? (
            <div style={{ position: "relative" }}>{<InfiniteLoader />}</div>
          ) : (
            ""
          )}
        </span>
      </div>
      <div className="pointer mt-2" style={{ width: "419px" }}>
        {files?.length > 0
          ? files?.map((file: any, index: any) => (
              <div key={index} className="d-flex flex-row align-items-center">
                <a
                  href={`${blobBaseUrl}${file?.file_url}?${blobToken}`}
                  target="_blank"
                  className="uploaded_file_name"
                >
                  {file?.file_name}
                </a>
                <div
                  className="ml-2"
                  onClick={() => handleDeleteUploadedFile(index)}
                >
                  <TrashIcon />
                </div>
              </div>
            ))
          : ""}
      </div>
    </>
  );
};

export default LeaveFileUpload;
